import { WallboxType } from './dto/types'

/** Wallbox types that can discharge a vehicle and therefore report `energyDischarged` */
export const DISCHARGE_CAPABLE_WALLBOX_TYPES: number[] = [WallboxType.Bidi, WallboxType.EDSN]
